// @ts-check

import { useMemo } from "react";
import { merge } from "lodash";
import { useOrgFeatureFlagsForTenant } from "./useOrgFeatureFlagsForTenant";
// import { useOrgFeatureFlagsForWorkspace } from "./useOrgFeatureFlagsForWorkspace";

/**
 * Hook for getting feature flags for UI.
 */
export const useOrgFeatureFlags = () => {
  const { loading: loadingTenant, featureFlags: tenantFeatureFlags } =
    useOrgFeatureFlagsForTenant();
  // const { loading: loadingWorkspace, featureFlags: workspaceFeatureFlags } =
  //  useOrgFeatureFlagsForWorkspace();

  const featureFlags = useMemo(() => {
    return merge(
      {},
      tenantFeatureFlags ?? {}
      // workspaceFeatureFlags ?? {}
    );
  }, [
    tenantFeatureFlags,
    // workspaceFeatureFlags
  ]);

  return {
    loading: loadingTenant /* || loadingWorkspace */,
    featureFlags,
  };
};
